import styled from '@emotion/styled'
import { Container } from 'components/layout'
import { PAGE_BREAKPOINTS } from 'parameters'

export const LearnContainer = styled(Container)`
	> div:nth-of-type(1) {
		margin-top: 25px;
	}

	> div {
		margin-bottom: 68px;
	}

	@media screen and (${PAGE_BREAKPOINTS.TABLET_LANDSCAPE}) {
		> div {
			margin-bottom: 48px;
		}

		> div:nth-of-type(1) {
			margin-top: 0;
		}
	}
`
